/**
 * Helper function to get the service URL based on user's country
 * Maps country IDs to their corresponding service pages
 */
export const getServiceUrlByCountry = (countryID: string): string => {
    const countryUrlMap: { [key: string]: string } = {
        '2fcbfdc4-9c25-4b58-874c-7c2625eaa750':
            'https://www.class1inc.com/en-ca/services', // Canada
        'abc5d95c-129f-4837-988c-0bf4ae1f3b67':
            'https://www.beaconmedaes.com/en-us/services', // USA
        '419ec375-dce2-41fb-8251-ce28caa507f5':
            'https://www.beaconmedaes.com/en-uk/services', // UK
        '5b831bfc-827e-45e1-b55d-a5f28c90d4b5':
            'https://www.beaconmedaes.cn/zh-cn/services', // China
        'c1785a25-0cc3-4c74-851e-8ba95d9db77a':
            'https://www.beaconmedaes.cn/zh-cn/services', // Taiwan
        '54d577c1-5e09-4f46-904e-620cba4bc82f':
            'https://www.beaconmedaes.cn/zh-cn/services', // Hong Kong
        '5ace6370-62a0-49b1-8dfc-1e15f735ffc8':
            'https://www.beaconmedaes.com/en-in/services' // India
    };

    // Return the mapped URL or default to UK version
    return (
        countryUrlMap[countryID] ||
        'https://www.beaconmedaes.com/en-uk/services'
    );
};
